import {AduanaDeExportacionSchema, PaginaGexSchema, type EdicionDeTramite} from '@cnc/contracts';
import {keepPreviousData, useMutation, useQuery, useQueryClient} from '@tanstack/react-query';
import {pedir} from './cliente';

// Tramite de aduana (GEX FR08) y pestaña GEX del seguimiento (decision 0019).
export function useGex(parametros: URLSearchParams) {
  const cadena = parametros.toString();
  return useQuery({
    queryKey: ['seguimiento', 'gex', cadena],
    queryFn: () => pedir(`seguimiento/gex${cadena ? `?${cadena}` : ''}`, PaginaGexSchema),
    placeholderData: keepPreviousData,
  });
}

export function useAduanaDeExportacion(codigo: string) {
  return useQuery({
    queryKey: ['seguimiento', 'aduana', codigo],
    queryFn: () => pedir(`seguimiento/exportaciones/${encodeURIComponent(codigo)}/aduana`, AduanaDeExportacionSchema),
    retry: false,
  });
}

export function useGuardarTramite(codigo: string) {
  const cliente = useQueryClient();
  return useMutation({
    mutationFn: (cuerpo: EdicionDeTramite) =>
      pedir(`seguimiento/exportaciones/${encodeURIComponent(codigo)}/aduana`, AduanaDeExportacionSchema, {
        method: 'PUT',
        headers: {'content-type': 'application/json'},
        body: JSON.stringify(cuerpo),
      }),
    onSuccess: datos => {
      cliente.setQueryData(['seguimiento', 'aduana', codigo], datos);
      void cliente.invalidateQueries({queryKey: ['seguimiento', 'gex']});
    },
    // Un conflicto (otra persona guardo antes) recarga los datos de ahora.
    onError: () => void cliente.invalidateQueries({queryKey: ['seguimiento', 'aduana', codigo]}),
  });
}
